import { formatDuration, DURATION_THRESHOLDS } from 'customer-data-property-utils/utils/dateAndDateTimeFormatting';
import { TextInput } from 'foundations-components/transitional/components/TextInput';
import I18n from 'I18n';
import { memo, useMemo } from 'react';
import useComponentMountMetric from '../metrics/useComponentMountMetric';
import { getTransferrableProps } from '../utils/getTransferrableProps';
import { parseNumericValue } from '../utils/parseNumericValue';
import { usePropertyValue } from '../v2/hooks/usePropertyValue';
import { jsx as _jsx } from "react/jsx-runtime";
const PropertyInputDuration = props => {
  const {
    autoFocus,
    inputRef,
    onChange
  } = props;
  const value = usePropertyValue();
  useComponentMountMetric('PropertyInputDuration');
  const displayValue = useMemo(() => {
    const parsedValue = parseNumericValue(value);
    if (parsedValue === null) {
      return '';
    }
    return formatDuration(I18n.moment.duration(Math.abs(parsedValue)), {
      thresholds: DURATION_THRESHOLDS,
      withSuffix: false
    });
  }, [value]);
  return /*#__PURE__*/_jsx(TextInput, Object.assign({}, getTransferrableProps(props), {
    onChange: onChange,
    autoFocus: autoFocus,
    inputRef: inputRef,
    value: displayValue || '',
    autoComplete: "off",
    readOnly: true
  }));
};
export default /*#__PURE__*/memo(PropertyInputDuration);